// removed by extract-text-webpack-plugin
module.exports = {"form":"_2eKH0NYRA2QdxPCknFB3vc","header":"rOxYcSBuScVhwhfoUkaN","button":"io5MpYZFUIrBZ0HlUvHqx","select":"_3WgRlyTayfQxpMLP6Ye03I"};


//////////////////
// WEBPACK FOOTER
// ./src/AddPractice/Practice/BusinessForm.css
// module id = 554
// module chunks = 0